<div class="d-flex flex-column gap-2 w-100">
  <span class="instruction-card-value">{{ frequency | vbPaymentChangeRecurringPaymentFrequencyLabel }}</span>
  <div class="d-flex justify-content-between gap-4">
    <span class="instruction-card-payment-label mt-auto mb-auto">{{ lastPaymentDateLabel }}</span>
    <div class="d-flex flex-column gap-2">
      <span class="instruction-card-value" i18n>{{
        activeRecurringPaymentInstruction?.paymentAmount
          | recurringPaymentFrequency : activeRecurringPaymentInstruction?.paymentFrequencyId
      }}</span>
      <div class="instruction-card-payment-label" [style.margin-left]="'auto'" i18n>{{ lastPaymentAmountType }}</div>
    </div>
  </div>
  <hr />
  <div class="d-flex justify-content-between gap-4">
    <span class="instruction-card-payment-label mt-auto mb-auto">{{ startingPaymentDateLabel }}</span>
    <div class="d-flex flex-column gap-2">
      <span class="instruction-card-value" i18n>{{
        scheduledRecurringPaymentInstruction?.paymentAmount
          | recurringPaymentFrequency : scheduledRecurringPaymentInstruction?.paymentFrequencyId
      }}</span>
      <div class="instruction-card-payment-label" [style.margin-left]="'auto'" i18n>
        {{ startingPaymentAmountType }}
      </div>
    </div>
  </div>
</div>
